import { replace } from "lodash";

const NumberUtils = {
  toNumber(inputStr) {
    inputStr = replace(inputStr, ",", ".");
    return parseFloat(inputStr);
  },
};

export function ccyFormat(number) {
  if (number == null || number == undefined) return 0;
  let thapPhan = `${number.toFixed(1)}`;
  let num = new Intl.NumberFormat().format(thapPhan);
  return num;
}
export function ccyFormatEx(number, phanThapPhan) {
  let result = 0
  if (number == null || number == undefined) return 0;
  if (isNaN(number))
    return 0;
  try {
    let thapPhan = `${number.toFixed(phanThapPhan)}`;
    result = new Intl.NumberFormat('en-IN').format(thapPhan);
    result = replace(result, ",", ".")
    //console.log(result)
  }
  catch (e) {
    //console.log("error:")
    //console.log(e)
    return number;
  }
  return result;
}
export function tienFormat(number, fixed) {
  if (number == null || number == undefined) return 0;
  let thapPhan = `${number.toFixed(fixed)}`;
  let num = new Intl.NumberFormat().format(thapPhan);
  return num;
}
export function tienFormatFixed(number, fixed) {
  if (number == null || number == undefined) return 0;
  let thapPhan = `${number.toFixed(fixed)}`;
  //let num = new Intl.NumberFormat().format(thapPhan);
  return thapPhan;
}
export function tienFormatSms(number, fixed) {
  if (number == null || number == undefined) return 0;
  let thapPhan = `${number.toFixed(fixed)}`;
  let num = new Intl.NumberFormat().format(thapPhan);
  return num.replace(",","").replace(".","");
}
export default NumberUtils;
